export const footerBackgroundClassesDark = '';
export const footerBackgroundClassesLight = '';
export const footerBackgroundClasses = 'bg-blue-800 text-white px-4 pt-10 pb-6 sm:px-8 lg:px-32';
export const footerInnerClasses =
  'w-full grid xl:max-w-7xl 2xl:pb-6 2xl:grid-cols-4 2xl:grid-rows-[repeat(4,_auto)]';
export const footerGridMenuClasses =
  'grid-cols-2 mb-11 lg:grid-cols-3 lg:gap-20 2xl:mb-0 2xl:col-span-3 2xl:col-start-1 2xl:row-span-4 2xl:row-start-1';
export const footerLinksContainerClasses =
  'sm:float-right sm:row-start-6 sm:col-[1] 2xl:flex 2xl:col-span-3 2xl:col-start-2 2xl:ml-14';
export const footerLinksClasses =
  'flex w-full justify-between text-xs whitespace-nowrap pb-4 sm:justify-end 2xl:items-center 2xl:justify-center 2xl:pb-0';
export const footerLegalClasses =
  'mt-1 flex w-full justify-start text-xs text-left sm:col-start-2 sm:justify-end 2xl:col-start-auto 2xl:mt-0 2xl:items-center';
export const footerSubscriptionContainerClasses =
  'lg:max-w-[50%] lg:row-[3] lg:col-[1] lg:w-fit 2xl:col-[4] 2xl:max-w-none 2xl:row-[2]';
export const footerSubsTextClasses = '';
const footerSubscriptionTextClasses = 'paragraph-m mb-4';
export const footerSocialContainerClasses =
  'mt-11 lg:ml-auto lg:self-end lg:row-[3] lg:col-[1] lg:mt-14 2xl:ml-0 2xl:col-[4]';
export const footerSocialTitleClasses = '';
export const footerSocialIconsClasses =
  'flex h-8 w-8 items-center justify-center rounded-sm bg-white text-blue-800 transition-all duration-500 hover:bg-blue-500 hover:text-white lg:h-10 lg:w-10 [&_svg]:fill-blue-800 [&:hover_svg]:fill-white';
export const footerMenuListContainerClasses = ['row-span-3', 'col-start-2', 'col-start-2 md:col-start-auto'];
export const footerMenuListClasses = 'mb-4 sm:mb-3';
export const footerMenuListItemClasses = 'extra-button font-medium transition-all hover:text-blue-500';
export const footerMenuTitleClasses = 'display-xs mb-4 sm:mb-3 [&_a:hover]:text-blue-500';
export const footerGetInContainerClasses = 'w-full row-start-1';
export const footerGetInTitleClasses = 'display-xs mb-2 font-bold';
export const footerGetInButtonsClasses = 'w-[320px] mb-11 grid gap-y-2 grid-cols-2 [&_div]:col-start-2';
export const footerGetInTouchButtonsClasses = '';
export const footerGetInPhoneClasses = 'text-[1.05rem] leading-6 font-bold transition-all hover:text-blue-500';
export const footerGetInPhoneIconClasses = 'mr-2 hidden';
export const footerDivider = 'bg-neutrals-500 col-span-full my-14 h-px w-full';
export const footerLogoClasses =
  'mb-6 flex w-full row-start-6 sm:float-left sm:col-[1] sm:mb-0 lg:justify-start 2xl:row-end-auto';

const footerBlogTheme = {
  footerBackgroundClassesLight,
  footerBackgroundClassesDark,
  footerBackgroundClasses,
  footerInnerClasses,
  footerGridMenuClasses,
  footerLinksContainerClasses,
  footerLinksClasses,
  footerLegalClasses,
  footerSubscriptionContainerClasses,
  footerSubsTextClasses,
  footerSubscriptionTextClasses,
  footerSocialContainerClasses,
  footerSocialTitleClasses,
  footerSocialIconsClasses,
  footerMenuListContainerClasses,
  footerMenuListClasses,
  footerMenuListItemClasses,
  footerMenuTitleClasses,
  footerGetInContainerClasses,
  footerGetInTitleClasses,
  footerGetInButtonsClasses,
  footerGetInPhoneClasses,
  footerGetInPhoneIconClasses,
  footerDivider,
  footerLogoClasses,
  footerGetInTouchButtonsClasses,
};

export default footerBlogTheme;
